"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectSiteMetadataDefinition = void 0;
function injectSiteMetadataDefinition() {
    return {
        author: `@progymedia`,
        pathPrefix: `/`,
        // FIXME: Ceci est une patch temporaire, à retirer une fois que le mécanisme de localisation sera bien en place.
        title: 'Site title FIXME',
        description: 'Site description FIXME',
    };
}
exports.injectSiteMetadataDefinition = injectSiteMetadataDefinition;
//# sourceMappingURL=inject-site-metadata-definition.js.map